import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import {
  faArrowRight,
  // Importing icons based on the new translation file structure
  faMicroscope, // for medicalDevices
  faWind,       // for cleanRooms
  faBolt,       // for electromechanical
  faCogs,       // for industrialManufacturing
  faBuilding    // for technicalInfrastructure
} from '@fortawesome/free-solid-svg-icons';
import './Services.css'; // Reutilizamos los estilos de Services
import './Industries.css'; // Estilos específicos de tarjetas fotográficas de sectores

// Foto real por sector (reemplaza los bloques azules solo-ícono, issue #418 P1-2)
const sectorImages = {
  medicalDevices: `${process.env.PUBLIC_URL}/images/industries/medical-devices.jpg`,
  cleanRooms: `${process.env.PUBLIC_URL}/images/industries/cleanroom.jpg`,
  electromechanical: `${process.env.PUBLIC_URL}/images/industries/electromechanical.jpg`,
  industrialManufacturing: `${process.env.PUBLIC_URL}/images/industries/manufacturing.jpg`,
  technicalInfrastructure: `${process.env.PUBLIC_URL}/images/industries/infrastructure.jpg`,
};

const Industries = () => {
  const { t } = useTranslation();

  // Helper to get icon reference from string
  const getIcon = (iconName) => {
    switch (iconName) {
      case 'FaMicroscope': return faMicroscope;
      case 'FaWind': return faWind;
      case 'FaBolt': return faBolt;
      case 'FaCogs': return faCogs;
      case 'FaBuilding': return faBuilding;
      default: return faArrowRight; // Fallback icon
    }
  };

  const highlightedSectors = t('industriesPage.highlightedSectors.sectors', { returnObjects: true }) || [];

  return (
    <div className="services-page industries-page"> {/* Added industries-page for specific styling if needed */}
      {/* Hero Section Modern */}
      <section className="page-hero modern-page-hero">
        <div className="page-hero-pattern"></div>
        <div className="page-hero-overlay"></div>
        <Container>
          <div className="page-hero-content">
            <div className="hero-badge animate-appear">
              <span className="hero-badge-text">{t('industriesPage.hero.badge')}</span>
            </div>
            <h1 className="animate-appear">{t('industriesPage.hero.title')}</h1>
            <p className="animate-appear">
              {t('industriesPage.hero.subtitle')}
            </p>
          </div>
        </Container>
      </section>

      {/* Main Content Overview Section */}
      {/* Issue #441: esta sección no tiene contenido debajo del párrafo, así que el
          mb-5 del párrafo + el padding-bottom de .modern-section + el padding-top
          de la siguiente sección sumaban ~210px de espacio muerto antes de
          "Sectores Destacados". Clase industries-overview-section lo ajusta. */}
      <section className="section modern-section industries-overview-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} md={12}>
              <h2 className="section-title modern-title text-center">{t('industriesPage.overview.title')}</h2>
              <p className="section-description text-center mb-0">
                {t('industriesPage.overview.description')}
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Highlighted Sectors Section */}
      {highlightedSectors.length > 0 && (
        <section className="section bg-light modern-section-light">
          <Container>
            <h2 className="section-title modern-title text-center">{t('industriesPage.highlightedSectors.title')}</h2>
            <div className="industry-sectors-grid">
              {highlightedSectors.map((sector) => (
                <div
                  className="industry-photo-card"
                  key={sector.id}
                  style={{ backgroundImage: `url(${sectorImages[sector.id] || ''})` }}
                  role="img"
                  aria-label={t(sector.name)}
                >
                  <div className="industry-photo-overlay">
                    <div className="industry-icon-wrapper mb-3">
                      <FontAwesomeIcon icon={getIcon(sector.icon)} className="industry-icon" aria-hidden="true" />
                    </div>
                    <h3 className="industry-title h5">{t(sector.name)}</h3>
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </section>
      )}

      {/* CTA Section - Kept from original */}
      <section className="section modern-cta-section">
        <Container className="text-center">
          <h2 className="cta-title">{t('industriesPage.cta.title')}</h2>
          <p className="cta-description mb-4">
            {t('industriesPage.cta.text')}
          </p>
          <Link to="/contacto">
            <Button variant="primary" size="lg" className="modern-button">
              {t('industriesPage.cta.button')} <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
            </Button>
          </Link>
        </Container>
      </section>
    </div>
  );
};

export default Industries; 